<template>
  <v-card outlined :class="isForBusiness ? 'numberplateBusiness' : 'numberplate'" class="mx-1">
    <v-row no-gutters justify="center" class="pt-0 pb-2">
      <span :class="isForBusiness ? 'numberplateBusinessText' : 'numberplateText'" class="text-center">{{ torokuChimeiBunruiDispValue }}</span>
    </v-row>
    <v-row no-gutters justify="center" class="pt-0 pb-2">
      <span :class="isForBusiness ? 'numberplateBusinessText' : 'numberplateText'" class="px-1 numberplate-text-kana-block text-center">{{ torokuHiragana }}</span>
      <span :class="isForBusiness ? 'numberplateBusinessText' : 'numberplateText'" class="pl-1 pr-2 numberplate-text-number">{{ torokuIchirenShiteiNoDispValue }}</span>
    </v-row>
  </v-card>
</template>
<style scoped>
  .numberplate {
    width: 160px!important;
    background-color:#fff;
    border-radius: 10px;
    border: 2px solid #1F2B38;
  }
  .numberplateBusiness {
    width: 160px!important;
    background-color:darkgreen;
    border-radius: 10px;
  }
  .numberplateText{
    color:#1F2B38;
    font-weight: bold;
  }
  .numberplateBusinessText{
    color:#fff;
    font-weight: bold;
  }
  .text-center {
    text-align: center;
  }
  .numberplate-text-kana-block {
    margin-top:0.1rem
  }
  .numberplate-text-number {
    float: right;
    font-size:2.4rem;
    text-align: right;
    padding-right:0.7rem;
  }
</style>
<script>

export default {
  name: 'DdNumberPlate',
  props: {
    isBusiness: Boolean,
    torokuChimei: String,
    torokuBunruiNo: String,
    torokuHiragana: String,
    torokuIchirenShiteiNo: String
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    torokuIchirenShiteiNoDispValue () {
      if ([undefined, null, ''].includes(this.torokuIchirenShiteiNo)) {
        return '･･ ･･'
      }
      var shiteiNo = ('････' + this.torokuIchirenShiteiNo).slice(-4)
      return shiteiNo.substring(0, shiteiNo.length - 2) + (this.torokuIchirenShiteiNo.length === 4 ? '-' : ' ') + shiteiNo.substring(shiteiNo.length - 2)
    },
    torokuChimeiBunruiDispValue () {
      var chimei = this.torokuChimei
      if ([undefined, null, ''].includes(this.torokuChimei)) {
        chimei = '---'
      } else {
        chimei = this.torokuChimei
      }
      return chimei + '　' + this.torokuBunruiNo
    },
    isForBusiness () {
      if (['あ', 'い', 'う', 'え', 'か', 'き', 'く', 'け', 'こ', 'を'].includes(this.torokuHiragana)) return true
      return false
    }
  }
}
</script>
